<template>
  <div class="product_inf" style="">
    <card
      title="产品溯源信息"
      style="color:#FFFFFF">
      <div style="padding:0rem 2rem 0.6rem 1.8rem;">
        <a-timeline style="margin-top:1rem">
          <a-timeline-item
            v-for="(item,index) in formdatas"
            :key="index"
            color="#faefac"
            style="color:#faefac">
            <div class="content_title widthStyle"> {{ item.titleWord }}</div>
            <div v-if="item.textualContent" class="widthStyle"> {{ item.textualContent }}</div>
            <span v-else>
                    <a style="color:#ff0000" @click="viewImg(item.attachmentContent)">查看</a>
            </span>
          </a-timeline-item>
        </a-timeline>
      </div>
    </card>
    <preview-modal ref="imageModal"></preview-modal>
  </div>
</template>

<script>
  import card from '@views/general/modules/Card.vue'
  import PreviewModal from '@views/general/modules/PreviewModal.vue'

  export default {
    name: 'WayInformation',
    components: { PreviewModal, card },
    props: {
      formdatas: {
        type: Array,
        default: () => ([])
      }
    },
    data() {
      return {}
    },
    methods: {
      viewImg(url) {
        // 预览静态图片
        this.$refs.imageModal.show(url)
      }
    }
  }
</script>


<style lang="less" scoped>
.widthStyle {
  width: 18rem;
  word-wrap: break-word;
}

.ant-carousel .slick-slide {
  text-align: center;
  height: 160px;
  line-height: 160px;
  background: #364d79;
  overflow: hidden;
}

.content_title {
  margin-bottom: 20px;
}

.ant-carousel .custom-slick-arrow {
  width: 25px;
  height: 25px;
  font-size: 25px;
  color: #fff;
  background-color: rgba(31, 45, 61, 0.11);
  opacity: 0.3;
}

.ant-carousel .custom-slick-arrow:before {
  display: none;
}

.ant-carousel .custom-slick-arrow:hover {
  opacity: 0.5;
}

.ant-carousel .slick-slide h3 {
  color: #fff;
}


.product_inf {
  /* position: relative; */
  /* height: 7rem; */
  /* background: url(../images/Product_inf_bg.jpg); */
  width: 100%;
  height: 100%;
  margin: 3rem auto;
  top: 8rem;
}

.yellowfont {
  color: #faefac;
}

.width100 {
  width: 100%;
  padding: 0.2rem 0;
}

.inlineblock {
  display: inline-block;
}

.minfont {
  font-size: 1rem !important;
}


/deep/ .ant-timeline-item-head {
  background-color: #faefac;
}

.btn-view {
  font-size: 1rem;
  color: #FF0000
}
</style>
